/* eslint-disable import/no-cycle */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './timelineComponent.scss';
import TimelineDataComponent from './timelineDataComponent';
import TimelineDatePicker from './timelineDatePicker/timelineDatePicker';
/**
 * Canvas component 
 */
const TimelineComponent = (props) => {
  const {
    value,blockSelected,onSelectItem,onDeselectItem,onMoveAndSelectItem,onMoveTime,onDeleteBlock,onFillBlock,onMoveToEnd,maxTime,minTime,
    maxTimeDisplayTimeline, dateSelected
  } = props;
  const [data,setData] =useState([]);

  useEffect(()=>{
    if(Object.keys("data")){
      setData(value);
    }
  },[value,blockSelected]);

  return (
    <div className="timelineComponent">
        <TimelineDataComponent 
            data={data} 
            dateSelected={dateSelected}
            blockSelected={blockSelected}
            onSelectItem={onSelectItem} 
            onDeselectItem={onDeselectItem}
            onMoveTime={onMoveTime}
            onMoveAndSelectItem={onMoveAndSelectItem}
            onDeleteBlock={onDeleteBlock}
            onFillBlock={onFillBlock}
            onMoveToEnd={onMoveToEnd}
            maxTime={maxTime}
            maxTimeDisplayTimeline={maxTimeDisplayTimeline}
            minTime={minTime}
        />      
    </div>);
};

TimelineComponent.propTypes = {
     /**
      * Function to propagate to parent to send to server the object
      */
     value:PropTypes.object
};

TimelineComponent.defaultProps = {
    value:{},
};
export default TimelineComponent;
